
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Plus, RefreshCw } from 'lucide-react';
import { Link } from 'react-router-dom';

export const OpportunitiesDashboardSection: React.FC = () => {
  // This is a placeholder. Actual data and table will be implemented later.
  const sampleOpportunities = [
    { id: 1, name: 'Ryan Nuessle - Necker Cup', company: 'Necker Cup', stage: 'Negotiation', probability: 'High%', revenue: '$50,000.00' },
    { id: 2, name: "Children's Hospital of Atlanta - Telecom Expense Management", company: "Children's Hospital", stage: 'Negotiation', probability: 'High%', revenue: '$10,000.00' },
    { id: 3, name: 'Melting Pot - Telecom Services, Telecom Expense Management', company: 'Melting Pot', stage: 'Negotiation', probability: 'High%', revenue: '$10,000.00' },
    { id: 4, name: 'David Shapiro - Business Development Services', company: 'Business Development', stage: 'Negotiation', probability: 'Medium%', revenue: '-' },
    { id: 5, name: 'Molly Fuller, Mary Jane Kirkpatrick - Necker Cup 2025', company: 'Necker Cup 2025', stage: 'Qualifying', probability: '%', revenue: '$10,000.00' },
  ];

  const getStageBadgeColor = (stage: string) => {
    if (stage === 'Negotiation') return 'bg-orange-100 text-orange-700';
    if (stage === 'Qualifying') return 'bg-blue-100 text-blue-700';
    return 'bg-gray-100 text-gray-700';
  };

  const getProbabilityBadgeColor = (probability: string) => {
    if (probability.toLowerCase().includes('high')) return 'bg-green-100 text-green-700';
    if (probability.toLowerCase().includes('medium')) return 'bg-yellow-100 text-yellow-700';
    return 'bg-gray-100 text-gray-700';
  };


  return (
    <Card className="col-span-1 lg:col-span-2"> {/* Adjusted to take more space */}
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <div>
          <CardTitle className="text-lg">Opportunities</CardTitle>
          <p className="text-sm text-muted-foreground">Manage your sales opportunities and track progress</p>
        </div>
        <div className="flex items-center space-x-2">
          <Button variant="outline" size="sm">
            <RefreshCw className="h-4 w-4 mr-2" />
            Refresh
          </Button>
          <Button size="sm" asChild>
            <Link to="/opportunity/new">
              <Plus className="h-4 w-4 mr-2" />
              Add Opportunity
            </Link>
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex items-center space-x-2 mb-4">
            <Input placeholder="Search opportunities by name, stage, probability..." className="h-9"/>
            <Button variant="outline" size="sm">Show Closed Opportunities</Button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left p-2 font-medium text-muted-foreground">Name</th>
                <th className="text-left p-2 font-medium text-muted-foreground">Stage</th>
                <th className="text-left p-2 font-medium text-muted-foreground">Probability</th>
                <th className="text-left p-2 font-medium text-muted-foreground">Revenue</th>
                <th className="text-left p-2 font-medium text-muted-foreground">Actions</th>
              </tr>
            </thead>
            <tbody>
              {sampleOpportunities.map(op => (
                <tr key={op.id} className="border-b">
                  <td className="p-2">
                    <div className="font-medium">{op.name}</div>
                    <div className="text-xs text-muted-foreground">{op.company}</div>
                  </td>
                  <td className="p-2">
                    <span className={`px-2 py-1 text-xs rounded-full ${getStageBadgeColor(op.stage)}`}>
                      {op.stage}
                    </span>
                  </td>
                  <td className="p-2">
                    <span className={`px-2 py-1 text-xs rounded-full ${getProbabilityBadgeColor(op.probability)}`}>
                      {op.probability}
                    </span>
                  </td>
                  <td className="p-2">{op.revenue}</td>
                  <td className="p-2">...</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-4 text-center text-sm text-muted-foreground">
          Full Opportunities table functionality will be implemented next.
        </p>
      </CardContent>
    </Card>
  );
};

